import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const LithuaniaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'LT',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Lithuania',
  SHORT_NAME: 'LT',

  DISPLAY_NAME: 'Lithuania (English)',
  DISPLAY_COUNTRY: 'Lithuania (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 55.1482053,
    INITIAL_LONGITUDE: 21.2448122,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Alytus County',
    '2': 'Kaunas County',
    '3': 'Klaipėda County',
    '4': 'Marijampolė County',
    '5': 'Panevėžys County',
    '6': 'Šiauliai County',
    '7': 'Tauragė County',
    '8': 'Telšiai County',
    '9': 'Utena County',
    '10': 'Vilnius Count',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-lt/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-lt/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default LithuaniaLocale
